import React from "react";
import { Download, ExternalLink } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const LINKS = [
  { label: "PNG Orizzontale (2048x1024)", variant: "main-png", desc: "Alta risoluzione per social, copertine, presentazioni" },
  { label: "JPG Orizzontale (2048x1024)", variant: "main-jpg", desc: "Compresso per web e email" },
  { label: "PNG Quadrato (1024x1024)", variant: "square-png", desc: "Profilo, avatar, favicon" },
  { label: "JPG Quadrato (1024x1024)", variant: "square-jpg", desc: "Compresso per profili social" },
];

export default function LogoDownloadPage() {
  return (
    <div className="min-h-screen bg-[#0a0e17] text-white py-12 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <h1 className="text-2xl sm:text-3xl font-black text-center mb-2" style={{
          fontFamily: "'Poppins', sans-serif",
          background: 'linear-gradient(135deg, #D4AF37 0%, #F5E6A3 40%, #D4AF37 60%, #B8942E 100%)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'
        }}>
          Logo Download HD
        </h1>
        <p className="text-gray-500 text-sm text-center mb-8">Clicca sul link — si apre nel browser — tasto destro &gt; Salva immagine</p>

        {/* Preview del logo */}
        <div className="bg-[#0a0e17] border-2 border-[#D4AF37]/30 rounded-2xl py-14 px-8 mb-8 flex flex-col items-center gap-5">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-center leading-tight" style={{
            fontFamily: "'Poppins', sans-serif",
            background: 'linear-gradient(135deg, #D4AF37 0%, #F5E6A3 40%, #D4AF37 60%, #B8942E 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'
          }}>
            schedabusiness.com
          </h2>
          <p className="text-lg sm:text-xl font-bold italic text-white/90 text-center" style={{
            fontFamily: "'Poppins', sans-serif",
            textShadow: '0 0 12px rgba(255,255,255,0.5), 0 0 24px rgba(255,255,255,0.2)'
          }}>
            se non ti trovano, non esisti
          </p>
        </div>

        {/* Link diretti — si aprono nel browser */}
        <div className="space-y-3">
          {LINKS.map(({ label, variant, desc }) => (
            <a
              key={variant}
              href={`${API}/api/logo/download/${variant}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between p-4 rounded-xl border border-white/10 bg-white/[0.03] hover:bg-[#D4AF37]/10 hover:border-[#D4AF37]/40 transition-all group"
              data-testid={`logo-link-${variant}`}
            >
              <div className="flex-1">
                <p className="text-white font-bold text-sm group-hover:text-[#F5E6A3] transition-colors">{label}</p>
                <p className="text-gray-500 text-xs">{desc}</p>
              </div>
              <div className="flex items-center gap-2 ml-4">
                <ExternalLink className="w-4 h-4 text-gray-500 group-hover:text-[#D4AF37] transition-colors" />
              </div>
            </a>
          ))}
        </div>

        <p className="text-gray-600 text-xs text-center mt-6">I link si aprono in una nuova tab. Tasto destro &gt; "Salva immagine con nome" per scaricare.</p>
      </div>
    </div>
  );
}
